import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "components/Button";
import { DataGridColumnConfig, DataGridFilterType } from "../types";
import { DataGridFilterRowHeader } from "../DataGridFilterRow";
import { DataGridSortModalInputs } from "./DataGridSortModalInputs";
import { useFilter } from "../useFilter";

export const DataGridSortModal: React.FC<{
    className?: string;
    filter?: DataGridFilterType;
    sortBy: string;
    sortAsc: boolean;
    columns: DataGridColumnConfig[];
    isSortOpen: boolean;
    isFilterEmpty: boolean;
    getFilterValue: ReturnType<typeof useFilter>["getFilterValue"];
    toggleFilter: (state?: boolean) => void;
    toggleSort: (state?: boolean) => void;
    onFilterClear: () => void;
    onSortClear: () => void;
    onFieldClean: (key: string) => void;
    onFilterInputFocus: (key: string) => void;
    onSortChange: (key: string, forceAsc?: boolean) => void;
}> = ({
    className,
    filter,
    sortBy,
    sortAsc,
    columns,
    isSortOpen,
    isFilterEmpty,
    getFilterValue,
    toggleFilter,
    toggleSort,
    onFilterClear,
    onSortClear,
    onFieldClean,
    onFilterInputFocus,
    onSortChange,
}) => {
    const inputsRef = useRef<React.ElementRef<typeof DataGridSortModalInputs> | null>(null);

    if (!columns?.[0]) return;

    const onClick = () => {
        const selectedSortBy = inputsRef.current?.selectedSortBy ?? columns[0].key;
        const selectedSortAsc = inputsRef.current?.selectedSortAsc;
        onSortChange(selectedSortBy, selectedSortAsc);
        toggleSort();
    };

    const onReset = () => {
        if (!inputsRef?.current) return;
        inputsRef.current.reset();

        onSortClear();
    };

    return (
        <Modal
            show={isSortOpen}
            onHide={toggleSort}
            aria-labelledby="data-grid-filter-modal"
            className={`d-table-row ${className}`}
            dialogClassName="m-0"
            contentClassName="rounded-0"
        >
            <Modal.Header className="rounded-0 border border-top-0  border-end-0 border-start-0 align-items-center">
                <DataGridFilterRowHeader
                    columns={columns}
                    filter={filter}
                    className="d-flex flex-shrink-0 gap-2"
                    toggleFilter={() => toggleFilter(true)}
                    toggleSort={toggleSort}
                    onFilterInputFocus={onFilterInputFocus}
                    onFieldClean={onFieldClean}
                    isFilterEmpty={isFilterEmpty}
                    onFilterClear={onFilterClear}
                />
            </Modal.Header>
            <Modal.Body className="py-3">
                <DataGridSortModalInputs
                    ref={inputsRef}
                    sortBy={sortBy}
                    sortAsc={sortAsc}
                    columns={columns}
                    getFilterValue={getFilterValue}
                />
            </Modal.Body>
            <Modal.Footer className="border-top d-flex">
                <Button
                    key="Reset"
                    style={{
                        color: "initial",
                        borderColor: "var(--bg-active) !important",
                    }}
                    className="me-auto bg-transparent border"
                    onClick={() => onReset()}
                >
                    Reset
                </Button>
                <Button variant="primary" onClick={() => onClick()}>
                    Apply
                </Button>
            </Modal.Footer>
            <hr className="m-0" />
        </Modal>
    );
};
